<template>
    <div class="aba-estoque select-modal">
        <alert-container :messages="msgs" />
        <div class="vertical-flow" v-show="!modalInsert">
            <div class="columns">
                <div class="column" :class="[permissao.create && !integracao ? 'is-6' : 'is-8']">
                    <search-bar :onSearch="debouncedOnSearch" tooltipLabel="msg-toltip-aba-saldo" />
                </div>

                <div class="column" :class="[permissao.create && !integracao ? 'is-3' : 'is-4']">
                    <vss-select
                        ref="situacaoSelect"
                        :searchable="false"
                        :options="situacaoSelect"
                        v-model="situacaoSelected"
                        mlLabels
                        title="situacao"
                        clearable
                        @input="onSituacaoChanged"
                        :height="40"
                    />
                </div>

                <div class="column is-3" v-if="permissao.create && !integracao">
                    <button class="save-btn botao-acao" type="button" @click="showModalCadastrar">
                        {{ $t('adicionar') }} {{ $t('estoque') }}
                    </button>
                </div>
            </div>

            <div class="registry-wrapper">
                <container-loader v-if="isLoading && !$store.getters.isLoading" />

                <empty-table-message v-if="isEmpty" />
                <b-table v-else :data="estoque" class="data-table">
                    <b-table-column
                        v-for="(f, i) in fields"
                        :key="i"
                        :field="f.key"
                        :width="f.width"
                        :class="{ 'excluir-field': f.key == 'excluir' }"
                        :sortable="f.sortable"
                        :custom-sort="f.sortFn"
                    >
                        <template slot="header">
                            <span v-if="f.key == 'codigo'">
                                {{ $t('codigo') }}
                            </span>

                            <span v-else-if="f.key == 'empresa'">
                                {{ $t('empresa') }}
                            </span>

                            <span v-else-if="f.key == 'vendedor'">
                                {{ $t('vendedor') }}
                            </span>

                            <span v-else-if="f.key == 'saldo'">
                                {{ $t('saldo') }}
                            </span>

                            <span v-else-if="f.key == 'replicapda'">
                                {{ $t('replicapda') }}
                            </span>

                            <span v-else-if="f.key == 'excluir'"> </span>
                        </template>

                        <template v-slot="props">
                            <div v-if="f.key == 'codigo'">
                                {{ props.row[f.key] }}
                            </div>
                            <div v-if="f.key == 'empresa'">
                                <a @click="selectedEdit(props.row)">
                                    {{ props.row[f.key] }}
                                </a>
                            </div>
                            <div v-if="f.key == 'vendedor'">
                                {{ props.row[f.key] }}
                            </div>
                            <div v-if="f.key == 'saldo'">
                                {{ props.row[f.key] }}
                            </div>
                            <div v-else-if="f.key == 'replicapda'">
                                <b-tag
                                    class="table-tag table-tag-full-width"
                                    :type="
                                        props.row['replicapda'] == 3 ? 'is-success' : 'is-danger'
                                    "
                                    size="is-medium"
                                >
                                    {{ $t(props.row['replicapda'] == 3 ? 'ativo' : 'inativo') }}
                                </b-tag>
                            </div>
                            <div v-if="f.key == 'excluir'">
                                <b-button
                                    v-if="permissao.update && !integracao"
                                    class="action-button"
                                    :type="
                                        props.row['replicapda'] == 3
                                            ? 'is-danger'
                                            : 'is-success'
                                    "
                                    :icon-right="
                                        props.row['replicapda'] == 3 ? 'delete' : 'check'
                                    "
                                    @click="promptChangeSituacao(props.row)"
                                    v-tippy 
                                    :title="$t(
                                        props.row['replicapda'] == 3
                                            ? 'desativar'
                                            : 'reativar'
                                    )"
                                />
                            </div>
                        </template>
                    </b-table-column>
                </b-table>
                <br /><br />
                <PaginationViewer
                    class="mb-0"
                    :resetPagination="pagination.resetPagination"
                    :totalItems="pagination.totalRows"
                    :perPageOptions="pagination.perPageOptions"
                    :optionStarted="pagination.optionStarted"
                    @change="updatePagination"
                />
            </div>
        </div>
        <!-- MODAL DE ASSOCIACAO -->
        <div>
            <SaldoModal
                :idsaldoprodutoremessa="this.idsaldoprodutoremessa"
                :integracao="integracao"
                :permissao="permissao"
                @fecharModal="fecharModal"
                @exibeMsg="exibeMsg"
                v-if="showModal"
                v-show="modalInsert"
            />
        </div>
    </div>
</template>

<script>
import SaldoProdutoService from '@/services/vendas/produto/SaldoProdutoService';
import SaldoModal from '@/components/vendas/produto/modal/dados-cadastrais/saldo/SaldoRemessaModalManage.vue';
import ContainerLoader from '@/components/content/loader/ContainerLoader';
import Message from '@/models/Message';

export default {
    components: {
        ContainerLoader,
        SaldoModal,
    },
    data() {
        return {
            integracao: this.$store.state.user.tabelasERPWebServer.includes('SALDOPRODUTOREMESSA'),
            estoque: [],
            fields: [
                { key: 'codigo', width: 100, sortable: false, sortFn: null },
                { key: 'empresa', width: null, sortable: false, sortFn: null },
                { key: 'vendedor', width: null, sortable: false, sortFn: null },
                { key: 'saldo', width: 100, sortable: false, sortFn: null },
                { key: 'replicapda', width: 80, sortable: false, sortFn: null },
                { key: 'excluir', width: 20, sortable: false, sortFn: null },
            ],
            service: new SaldoProdutoService(this.$http, this.$router),
            permissao: false,
            pagination: {
                resetPagination: false,
                perPageOptions: [10, 25, 50, 100],
                optionStarted: 0,
                perPage: null,
                totalRows: 0,
                currentPage: 1,
            },
            situacaoSelected: { id: 4, label: 'todos' },
            situacaoSelect: [
                { id: 4, label: 'todos' },
                { id: 3, label: 'ativos' },
                { id: 2, label: 'inativos' },
            ],
            isLoading: false,
            isEmpty: false,
            isSaving: false,
            delete: null,
            showModal: false,
            asscontatocliente: null,
            idsaldoprodutoremessa: null,
            debouncedOnSearch: null,
            idproduto: 0,
            modalInsert: false,
            abaSelecionada: 0,
            abas: ['saldo', 'saldograde', 'saldoremessa'],
            abasAbertas: {},
            queryFilter: '',
            msgs: [],
            empresas: [],
        };
    },
    created() {
        this.pagination.perPage = this.pagination.perPageOptions[this.pagination.optionStarted];

        this.permissao = this.hasPermissionAccess(
            'vendas',
            'produtos',
            'ven-produto-dados-cadastrais-saldo'
        );

        if (!this.permissao.read) {
            this.$router.push({
                name: 'acesso-nao-permitido',
                params: { tela: 'saldo' },
            });
        } else {
            this.idproduto = this.$route.params.id;
            this.loadEmpresas();
            this.carregarDados();
            this.debouncedOnSearch = this.debounce(this.onSearch, 500);
        }
    },
    methods: {
        loadEmpresas() {
            if (this.$store.state.user.admin) {
                // se for admin, mostra todas as empresas
                this.$store.state.empresas.data.map((e) => {
                    this.empresas.push({ id: e.id, label: e.rsocial });
                });
            } else {
                // se for cliente, mostra todas as empresas relacionadas a ele
                this.$store.state.user.empresas.map((e) => {
                    this.empresas.push({ id: e.id, label: e.rsocial });
                });
            }
        },
        onSearch(value) {
            this.queryFilter = value;
            this.pagination.currentPage = 1;
            this.carregarDados();
        },
        carregarDados(currentPage = 1) {
            if (this.empresas.length == 0) {
                this.isEmpty = true;
                return;
            }
            if (currentPage == 1 && this.pagination.currentPage != 1)
                this.pagination.resetPagination = true;

            this.isLoading = true;

            this.service
                .loadEstoqueRemessa(
                    currentPage - 1,
                    this.pagination.perPage,
                    this.situacaoSelected.id,
                    this.idproduto,
                    this.queryFilter
                )
                .then(this.mapItems)
                .then((value) => {
                    this.estoque = value;
                    this.isEmpty = this.estoque.length <= 0;
                })
                .catch((e) => {
                    this.isEmpty = true;
                    this.$root.showMessage('error', 'msg-erro-load');
                    console.error('Erro ao carregar os dados!');
                })
                .finally((_) => {
                    this.isLoading = false;
                    this.pagination.resetPagination = false;
                });
        },
        mapItems(body) {
            this.pagination.totalRows = body.totalElements;

            return body.content.map((m) => {
                return {
                    codigo: m.idsaldoprodutoremessa,
                    empresa: m.empresa.nome,
                    saldo: m.saldo,
                    vendedor: m.usuario.nome ? m.usuario.nome : '---',
                    replicapda: m.replicapda,
                    excluir: 'excluir',
                };
            });
        },
        updatePagination(value) {
            this.pagination.resetPagination = false;
            this.pagination.perPage = value.perPage;
            this.pagination.currentPage = value.currentPage;
            this.carregarDados(value.currentPage);
        },
        onSituacaoChanged(val) {
            this.situacaoSelected = val
                ? this.situacaoSelect.filter((v) => v.id == val.id)[0]
                : this.situacaoSelect[0];
            this.carregarDados();
        },
        promptChangeSituacao(row) {
            this.delete = row;
            let message = this.$t(
                    row.replicapda == 3
                        ? 'msg-confirmacao-desativacao-n'
                        : 'msg-confirmacao-reativacao-n', 
                    { n: this.$t('registro') + ' ' + this.delete.codigo }
                );
            this.$root.confirm({
                message: message,
                onConfirm: this.updateSituacaoRegistro,
                onCancel: this.removePrompt,
            });
        },
        removePrompt() {
            this.delete = null;
        },
        updateSituacaoRegistro() {
            let temp = {
                idsaldoprodutoremessa: this.delete.codigo,
                replicapda: this.delete.replicapda == 3 ? 2 : 3,
            };

            this.isLoading = true;

            this.service
                .updateSituacaoRemessa(temp)
                .then((r) => {
                    if (r.status == 200) {
                        let tempSuccess = this.$t(
                                this.delete.replicapda == 3
                                    ? 'msg-sucesso-ao-reativar'
                                    : 'msg-sucesso-ao-desativar', 
                                { n: this.$t('registro') + ' ' + this.delete.codigo }
                            );
                        this.$root.showMessage('success', tempSuccess, true, false);
                        this.carregarDados(this.pagination.currentPage);
                    } else if (r.status == 500) {
                        this.$root.showMessage('error', 'Erro ao atualizar status.');
                    }
                })
                .catch((e) => {
                    console.error('Erro ao atualizar status.', e);
                    // novo modelo de mensagem dinâmica
                    let msg = this.$t(
                            this.delete.replicapda == 3
                                ? 'msg-erro-ao-reativar'
                                : 'msg-erro-ao-desativar', 
                            { n: this.$t('registro') + ' ' + this.delete.codigo }
                        );

                    this.$root.showMessage('error', msg, true, false);
                })
                .finally((_) => {
                    this.isLoading = false;
                    this.delete = null;
                });
        },
        showModalCadastrar() {
            this.$emit('emEdicao', true);
            this.modalInsert = true;
            this.idsaldoprodutoremessa = null;
            this.asscontatocliente = null;
            this.showModal = !this.showModal;
        },
        fecharModal() {
            this.$emit('emEdicao', true);
            this.modalInsert = false;
            this.showModal = false;
            this.asscontatocliente = null;
            this.carregarDados();
        },
        exibeMsg(msg) {
            this.msgs.push(new Message('success', msg, true, false));
        },
        selectedEdit(select) {
            this.$emit('emEdicao', true);
            this.modalInsert = true;
            this.idsaldoprodutoremessa = select.codigo;
            this.showModal = !this.showModal;
        },
    },
};
</script>

<style lang="scss" scoped>
.aba-estoque {
    height: 100%;

    .botao-acao {
        margin-top: 24px;
        width: 100%;
        height: 40px;
    }

    @media (max-width: 760px) {
        .search-bar {
            padding-bottom: 0.4rem;
        }
        .botao-acao {
            margin-top: 0;
        }
    }
}
</style>
